<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <rect x="9" y="3" width="6" height="4" rx="1" stroke="currentColor" stroke-width="1.75" />
  <rect x="3" y="10" width="6" height="4" rx="1" stroke="currentColor" stroke-width="1.75" />
  <rect x="15" y="10" width="6" height="4" rx="1" stroke="currentColor" stroke-width="1.75" />
  <path d="M12 7V10M6 14V17M18 14V17" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" />
  <rect x="9" y="17" width="6" height="4" rx="1" stroke="currentColor" stroke-width="1.75" />
</svg>
